export const PLAYTHROUGH_STATUS_VALUES = ["in_progress", "completed", "abandoned"];
export const PlaythroughStatus = {
    IN_PROGRESS: "in_progress",
    COMPLETED: "completed",
    ABANDONED: "abandoned",
};
